import { get, post, patch, del } from "@/services/axiosUitils";
import {
  IPO,
  CreateIPOPayload,
  UpdateIPOPayload,
  GetIPOListResponse,
  IPOGetByIdResponse,
  IPOCreatePayload,
  IPOList,
  SyncIPOResponse,
  GetMemberListResponse,
  GetApplicationGroupResponse,
  CreateMemberPayload,
  UpdateMemberPayload,
  ApplyIPOPayload,
} from "@/utils/types/IPO/ipo";

const basePath = "/ipo/ipos/";
const memberBasePath = "/ipo/members/";

class IPOService {
  list = async (
    page: number,
    page_size: number,
    filters?: Record<string, string | number | boolean>
  ): Promise<GetIPOListResponse> => {
    const params: Record<string, string | number | boolean> = {
      page,
      page_size: page_size,
    };
    if (filters?.search) {
      params.search = filters.search;
    }
    if (
      filters?.ipoStatus &&
      String(filters.ipoStatus).toLowerCase() !== "all"
    ) {
      params.ipoStatus = filters.ipoStatus;
    }
    return await get<GetIPOListResponse>(basePath, { params });
  };

  getById = async (id: string): Promise<IPO> => {
    return await get<IPO>(`${basePath}${id}/`);
  };

  getIPOById = async (id: string): Promise<IPOGetByIdResponse> => {
    return await get<IPOGetByIdResponse>(`${basePath}${id}/`);
  };

  create = async (payload: CreateIPOPayload): Promise<IPO> => {
    return await post<IPO, CreateIPOPayload>(basePath, payload);
  };

  createIPO = async (payload: IPOCreatePayload): Promise<IPOList> => {
    return await post<IPOList, IPOCreatePayload>(basePath, payload);
  };

  update = async (id: string, payload: UpdateIPOPayload): Promise<IPO> => {
    return await patch<IPO, UpdateIPOPayload>(`${basePath}${id}/`, payload);
  };

  delete = async (id: string): Promise<void> => {
    return await del<void>(`${basePath}${id}/`);
  };

  getIPOList = async (): Promise<GetIPOListResponse> => {
    return await get<GetIPOListResponse>(basePath);
  };

  syncIPO = async (): Promise<SyncIPOResponse> => {
    return await post<SyncIPOResponse>(`${basePath}sync/`);
  };

  getMemberList = async (): Promise<GetMemberListResponse> => {
    return await get<GetMemberListResponse>(memberBasePath);
  };

  getMemberListAdminList = async (): Promise<GetMemberListResponse> => {
    return await get<GetMemberListResponse>(`${memberBasePath}admin-list/`);
  };

  createMember = async (payload: CreateMemberPayload): Promise<any> => {
    return await post<any, CreateMemberPayload>(memberBasePath, payload);
  };

  updateMember = async (
    id: string,
    payload: UpdateMemberPayload
  ): Promise<any> => {
    return await patch<any, UpdateMemberPayload>(
      `${memberBasePath}${id}/`,
      payload
    );
  };

  deleteMember = async (id: string): Promise<any> => {
    return await del<any>(`${memberBasePath}${id}/`);
  };

  getApplicationGroup = async (): Promise<GetApplicationGroupResponse> => {
    return await get<GetApplicationGroupResponse>(
      `${basePath}apply/admin-list/`
    );
  };

  applyIPO = async (payload: ApplyIPOPayload): Promise<any> => {
    return await post<any, ApplyIPOPayload>(`${basePath}apply/`, payload);
  };

  IPODetilsFetchFromAI = async (id: string): Promise<any> => {
    return await post<any>(`${basePath}${id}/ai-fill-details/`);
  };
}

export default new IPOService();
